// extracted by mini-css-extract-plugin
export default {"homes":"home_homes__VziHi","left":"home_left__1W77T","resumeButton":"home_resumeButton__zRCFL","backgroundImg":"home_backgroundImg__2WDe5","right":"home_right__WYRAG"};